    <div class="container-fluid page-content">

        <div class="row">
            <div class="col">
                <label class="title">Combustibles</label>
            </div>
        </div>

        <div class="row">
            <div class="col text-end">
                <button (click)="abrirModalCrearCombustible()" class="btn btn-sm btn-success rounded-button">
                    <i class="fas fa-plus"></i>&nbsp;
                    Nuevo combustible
                </button>
            </div>
        </div>

        <div class="row mt-3">
            <p-table #dt [value]="listaCombustibles" [scrollable]="true" [scrollHeight]="'calc(100vh - 260px)'" [paginator]="true" [rows]="20" [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}" [rowsPerPageOptions]="[20,50,100,200]">

                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="tipo" class="medium-col" style="border-top-left-radius: 15px;">Tipo</th>
                        <th pSortableColumn="descripcion" class="medium-col">Descripción</th>
                        <th class="medium-col" style="border-top-right-radius: 15px;">Acción</th>
                    </tr>

                    <tr class="filter-row">
                        
                        <th class="filter-row">
                            <input placeholder="Filtrar" #filtroTipo type="text" class="form-input form-input-table-filter" (input)="dt.filter(filtroTipo.value, 'tipo', 'contains')">

                        </th>
                        <th class="filter-row">
                            <input placeholder="Filtrar" #filtroDescripcion type="text" class="form-input form-input-table-filter" (input)="dt.filter(filtroDescripcion.value, 'descripcion', 'contains')">
                        </th>
                    <th></th>    
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" class="animated fadeIn fast" let-combustible>

                    <tr>
                        <td class="medium-col">{{combustible.tipo }}</td>
                        <td class="medium-col">{{combustible.descripcion}}</td>
                        <td class="medium-col">
                            <button type="button" (click)="abrirModalEditarCombustible(combustible)" style="font-size:12px; width: 100px;" class="btn btn-xs my-button-blue-outline rounded-button">
                                <i class="far fa-edit"></i>&nbsp;
                                Editar
                            </button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>

        </div>

    </div>